import { FormField } from '@alice-financial/alice-sdk'
import React from 'react'
import { fieldAnswer } from './questionTypes/formFieldUtils'
import { Question, QuestionPage, SurveyFieldValues } from './types'

export const useValuesFromApi = (
  formFields: FormField[] | undefined,
  pages: readonly Pick<QuestionPage, 'questions'>[]
): SurveyFieldValues => {
  return React.useMemo(
    () =>
      pages
        .flatMap(({ questions }) => questions)
        .reduce((acc, question) => {
          const answer = fieldAnswer(formFields, question.questionId)
          acc[question.questionId] = question.getFieldValue(answer)
          return acc
        }, {} as SurveyFieldValues),
    [formFields, pages]
  )
}

/**
 * Read form input values and return the form fields to be saved to the database,
 * along with a dedicated 'complete' field to indicate if the form has been completed.
 */
export const parseFormInputs = (allQuestions: Question[], values: SurveyFieldValues) => {
  return allQuestions.reduce<{ complete: boolean; formFields: FormField[] }>(
    (acc, { questionId, questionText: question, getAnswer, required }) => {
      // @ts-expect-error - values guaranteed to have correct key-value
      const answer = getAnswer(values)
      if (required && !answer) acc.complete = false
      acc.formFields.push({ question, answer, questionId })
      return acc
    },
    {
      complete: true,
      formFields: [],
    }
  )
}
